import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ContactPage from '../containers/ContactPage';
import ImprintPage from '../containers/ImprintPage';
import { getRouterBasename } from '../utils/basePath';
import { contactPageRoutePrefix } from './router.constants';

const contactPageRoutePath =
  contactPageRoutePrefix === '/'
    ? '/*'
    : `${contactPageRoutePrefix.replace(/\/$/, '')}/*`;

function MainRouter() {
  return (
    <BrowserRouter basename={getRouterBasename()}>
      <Routes>
        <Route path="/imprint" element={<ImprintPage />} />
        <Route path={contactPageRoutePath} element={<ContactPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default MainRouter;
